<template>
  <div id="slide-6" class="slide">
    <img src="../assets/images/main-line-3.svg" alt="main-line-3" class="line-img main-line-3">
    <div class="container slide-content">
      <div class="row">
        <div class="col-md-7 offset-md-1 col-sm-12">
          <p class="p-20 my-3 is-bold" v-if="isDesktop">Now, here’s your result…</p>

          <div v-if="sameJourneys >= 115">
            <h1 class="is-pink my-4" >You’re on a popular route: {{ sameJourneys | localeString }} Londoners do the same journey as you every day.</h1>
            <p class="p-20">That’s enough to fill {{ carriages }}! If that figure looks lower than you expect that’s because it only counts Londoners starting their journey at {{ stationFrom.name }} and ending it at {{ stationTo.name }}.</p>
          </div>
          <div v-else-if="sameJourneys < 115 && sameJourneys > 9">
            <h1 class="is-pink my-4" >{{ sameJourneys }} Londoners do the same journey as you every day.</h1>
            <p class="p-20">They could all fit in a single Tube carriage! If that figure looks lower than you expect that’s because it only counts Londoners starting their journey at {{ stationFrom.name }} and ending it at {{ stationTo.name }}.</p>
          </div>
          <div v-else>
            <h1 class="is-pink my-4">Fewer than 10 Londoners do the same journey as you every day.</h1>
            <p class="p-20">Your journey is as rare as a seat on a rush hour train. If that figure looks lower than you expect that’s because it only counts Londoners starting their journey at {{ stationFrom.name }} and ending it at {{ stationTo.name }}.</p>
          </div>

          <p class="p-26 is-bold">Will you share your result with your friends to see who takes the most popular route every day?</p>

          <div id="all-shares">
            <p>{{ shares.allShares | localeString }} other Londoners have shared their result with their friends.</p>
          </div>

          <button class="btn btn-purple" @click="changeSlide(7, $event)">Yes</button>
          <button class="btn btn-gray" @click="changeSlide(8, $event)">No</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sameJourneys: {
      type: Number,
      default: 1
    },
    shares: Object,
    usersTest: Boolean,
    stationFrom: Object,
    stationTo: Object
  },

  data() {
    return {
    }
  },

  computed: {
    carriages() {
      let journeys = Math.round(this.sameJourneys / 115);
      let carriages = journeys > 1 ? 'carriages' : 'carriage';
      return `${journeys} Tube ${carriages}`;
    },

    isDesktop() {
      return window.innerWidth >= 1024;
    }
  },

  methods: {
    changeSlide(i) {
      this.$emit('changeSlide', i);
      this.$ga.event('FA - data journey', 'Slide 5', 'Passed');
      this.$ga.event('FA - data journey', 'Will you share?', event.target.innerHTML);
    }
  },

  filters: {
    localeString(n) {
      return n.toLocaleString();
    }
  }
}
</script>

<style lang="scss" scoped>
  h2 {
    font-size: 44px;
    line-height: normal;
  }

  .btn-purple,
  .btn-gray {
    padding: 12px 45px;
    margin-top: 30px;
  }

  .btn-gray {
    margin-left: 30px;
  }

  .main-line-3 {
    position: absolute;
    bottom: 0;
    right: 200px;
  }

  @media screen and (max-width: 1200px) {

  }

  @media screen and (max-width: 900px) {
    h2 {
      font-size: 32px;
      line-height: 1.36;
    }
  }

  @media screen and (max-width: 767px) {
    .slide-content {
      margin-top: 0;
    }

    h2 {
      font-size: 28px;
      line-height: 1.36;
    }

    .btn-purple,
    .btn-gray {
      display: block;
      width: 100%;
      margin: 20px 0;
    }

    .btn-purple {
      margin-top: 50px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Slide6.vue